<template lang="pug">
	.voice-creator--list.tb-padding
		ListView.full-width(ref="listView", initialView="table", :hideViewsSelection="true", :getTotal="(r) => r.TotalNumberOfRecords", :getItems="(r) => r.Results", :getData="loadData", :columns="columns",
			:showColumnHeaders="true", :searchVisible="true", :autoFit="true", :bottomPagerVisible="false", :filterRow="false", :keyboardNavigationDisabled="true", :showPageSize="true")
			template(v-slot:item-template="{ data }")
				.flex-col.space 
					a.font-big(@click="openProject(data)") {{ data.Name }}
					.grey {{ data.Description }}
			.flex-row.space.align-center(slot="left-actions")
				.font-big.upper {{$tCaption('Voice cloning projects')}}
				DxButton(icon="plus", stylingMode="outline", @click="addNewProject")
		Popup(v-if="newProjectPopupVisible", :popupVisible.sync="newProjectPopupVisible", :title="$tCaption('New project')", :autosize="true", :width="480", :closeOnOutsideClick="false")
			.content
				.flex-col.space-medium
					.flex-col
						.font-small.upper.grey {{ $tCaption('Name') }}
						DxTextBox(:value.sync="newProject.Name", stylingMode="filled", :disabled="!!isLoading")
					.flex-col
						.font-small.upper.grey {{ $tCaption('Gender') }}
						DxSelectBox(:value.sync="newProject.Gender", :disabled="!!isLoading", :dataSource="genders", displayExpr="name", valueExpr="id", stylingMode="filled")
					.flex-col
						.font-small.upper.grey {{ $tCaption('Description') }}
						DxTextArea(:value.sync="newProject.Description", :height="80", stylingMode="filled", :disabled="!!isLoading")
				Loader(v-if="isLoading", text="", :fullscreen="true")
			template(slot="actions-right")
				DxButton(:text="$tCaption('Cancel', '@actions')", @click="newProjectPopupVisible = false", :disabled="!!isLoading")
				DxButton(:text="$tCaption('Save', '@actions')", @click="saveNewProject", type="success", :disabled="!!isLoading")
</template>

<script>
import ListView from 'app-core/ListView.vue';
import DxButton from 'devextreme-vue/button';
import DxTextBox from 'devextreme-vue/text-box';
import DxTextArea from 'devextreme-vue/text-area';
import Popup from 'app-core/Popup.vue';
import Loader from 'app-core/Loader.vue';
import { VOICE_CREATOR_PUBLISHING_STATUS } from 'app-core/constants';
import DxSelectBox from 'devextreme-vue/select-box';

export default {
	translationCategory: 'voiceCreator.List',
	components: { ListView, DxButton, Popup, Loader, DxTextBox, DxTextArea, DxSelectBox },
	props: [],
	data() {
		const publishingStatus = VOICE_CREATOR_PUBLISHING_STATUS.toLocale('name', this);
		return {
			columns: [
				{ dataField: 'Name', caption: () => this.$tCaption('Project'), cellTemplate: 'item-template' },
				{
					dataField: 'ProjectPublishingStatus',
					caption: this.$tCaption('Status'),
					lookup: {
						dataSource: publishingStatus,
						displayExpr: 'name',
						valueExpr: 'id'
					}
				},
			],
			newProjectPopupVisible: false,
			newProject: {
				Name: '',
				Description: '',
				Gender: 0
			},
			isLoading: 0,
			publishingStatus,
			genders: [this.$tCaption('Male'), this.$tCaption('Female')].map((f, i) => ({ id: i, name: f })),
		};
	},
	computed: {
		
	},
	watch: {
		
	},
	mounted() {
		if (__DEBUG__)
			window.voiceCreatorList = this;
	},
	destroyed() {		
	},
	methods: {
		loadData(page, limit, opts) {
			let filter = opts?.filter;
			if (opts?.searchString) {
				filter = [["Name", "contains", opts?.searchString], "OR", ["Description", "contains", opts?.searchString]];
			}
			let filterCriteria = `${filter && filter.length && `&filterCriteria=${encodeURIComponent(JSON.stringify(filter))}` || ''}`;
			let sorting = `&sorting=[{ selector: 'Created', desc: true }]`;
			return this.$Data.getExternalApi('VoiceProject/List', `page=${page + 1}${filterCriteria}${sorting}`)
		},
		saveNewProject() {
			this.isLoading++;
			this.$Data.postExternalApi('VoiceProject/CreateUpdate', this.newProject)
			.then(r => {
				if (r?.Success !== false && r.Data?.Oid) {
					this.$notifySuccess(this.$tCaption('New project was created successfully'));
					this.newProjectPopupVisible = false;
					this.$router.push({ path: `voice-creator/${r?.Data?.Oid}` });
				}
			})
			.finally(() => {
				this.isLoading--
			});
		},
		addNewProject() {
			this.newProject.Name = '';
			this.newProject.Description = '';
			this.newProjectPopupVisible = false;
			this.$nextTick(() => this.newProjectPopupVisible = true);
		},
		openProject(project) {
			this.$router.push({ path: `voice-creator/${project?.Oid}` });
		}
	}
};
</script>
<style lang="scss">
	@import "main/themes/generated/variables.base.scss";
	.voice-creator--list {
		
	}
</style>
